import {createContext} from 'react';
import {UrlParams} from 'universal-router/generateUrls';
import {BrowserHistory} from 'history';

export interface RouterReactContextValue {
	history?: BrowserHistory;
	urlGenerator(routeName: string, params?: UrlParams): string;
}

export const RouterReactContext = createContext<RouterReactContextValue | null>(null);
RouterReactContext.displayName = 'RouterReactContext';
